import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router';
import clsx from 'clsx';
import { useLayout } from '../core';
import { isFluidLayoutPath, toFluidContainerClass } from '../core/fluidLayoutPaths';
import { DrawerComponent } from '../../assets/ts/components';

const Content = ({ children }) => {
    const { classes } = useLayout();
    const location = useLocation();
    useEffect(() => {
        DrawerComponent.hideAll();
    }, [location]);

    const containerClassName = useMemo(
        () => toFluidContainerClass(classes.contentContainer, isFluidLayoutPath(location.pathname)),
        [classes.contentContainer, location.pathname]
    );

    return (<div id='kt_content_container' className={clsx(containerClassName)}>
      {children}
    </div>);
};
export { Content };
